<div class="w-full h-full flex flex-col gap-6 p-4">
    <p-toast></p-toast>
    <div class="rounded-md shadow-md p-2 w-full bg-white flex flex-col gap-2">

        <div class="h-12 flex flex-row gap-4 items-center">
            <div matTooltip="{{'This feature is in beta testing'|translate}}"
                class="px-2 py-1 rounded-sm bg-tachosafe-500 text-white shadow-md  font-extrabold  text-lg">
                PRO</div>
            <!-- <div matTooltip="{{'This feature is in beta testing'|translate}}"
                class="px-2 py-1 rounded-sm bg-yellow-500 text-white shadow-md  font-extrabold  text-lg">
                BETA</div> -->
            <div class="text-3xl font-bold">{{'Download all files' | translate}}</div>
        </div>
        <div class="w-full flex flex-row gap-2 justify-between">
            <div class="flex flex-row gap-2">
                <label class="flex flex-col">
                    <div class="text-slate-500">{{'Select company'| translate}}</div>
                    <p-multiSelect [options]="companies" [(ngModel)]="selectedCompanies" [style]="{'width':'20rem'}"
                        defaultLabel="{{'Select companies to download files' | translate}}" optionLabel="name"
                        [filter]="true" filterBy="name" [virtualScroll]="true" itemSize="50" display="chip">
                        <ng-template let-value pTemplate="selectedItems">
                            <div *ngIf="!value || value.length==0" class="w-64 h-6">
                                {{'Select companies to download files' | translate}}
                            </div>
                            <div *ngIf="!!value && value.length>0" class="w-64 h-8 flex flex-col justify-center">
                                {{value.length}} {{'companies selected' | translate}}
                            </div>
                        </ng-template>
                    </p-multiSelect>
                </label>
                <label class="flex flex-col">
                    <div class="text-slate-500 inline-flex flex-row gap-1 items-center">
                        {{'Select period'| translate}}
                        <mat-icon class="text-base w-4 h-4"
                            matTooltip="{{'Period refers to when files were uploaded'|translate}}">info</mat-icon>
                    </div>
                    <p-calendar placeholder="{{'Select period' | translate}}" [(ngModel)]="rangeDates"
                        selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>
                </label>
                <label class="flex flex-col">
                    <div class="text-slate-500">{{'Select file types'| translate}}</div>
                    <p-multiSelect [options]="fileTypes" [(ngModel)]="selectedFileTypes"
                        defaultLabel="{{'Select file types' | translate}}" optionLabel="name" display="chip">
                        <ng-template let-value pTemplate="selectedItems">
                            <div class="flex flex-row gap-1">
                                <div *ngFor="let selectedItem of selectedFileTypes"
                                    class="py-1 px-2 bg-slate-100 rounded-md">{{selectedItem.name | translate}}</div>
                            </div>
                        </ng-template>
                        <ng-template let-fileType pTemplate="item">
                            <div class="">{{fileType?.name | translate}}</div>
                        </ng-template>
                    </p-multiSelect>
                </label>
            </div>
            <button
                [disabled]="!!progress || !isPro || !selectedCompanies.length || !rangeDates || !selectedFileTypes.length"
                (click)="exportAllFiles()"
                class="text-white px-2 py-1 bg-tachosafe-500 font-bold mt-5 disabled:bg-slate-300">{{'Download'|
                translate}}</button>
        </div>

        <div *ngIf="!!progress" class="flex flex-col gap-2">
            <div>{{'Downloading..'|translate}}</div>
            <div class="w-full bg-tachosafe-200 rounded-full h-2.5 dark:bg-gray-700">
                <div class="bg-tachosafe-600 h-2.5 rounded-full" [style]="{width: progress+'%'}"></div>
            </div>
        </div>
    </div>

    <!-- New section for download by driver and vehicle -->
    <div class="rounded-md shadow-md p-2 w-full bg-white flex flex-col gap-2">
        <div class="h-12 flex flex-row gap-4 items-center">
            <div matTooltip="{{'This feature is in beta testing'|translate}}"
                class="px-2 py-1 rounded-sm bg-tachosafe-500 text-white shadow-md  font-extrabold  text-lg">
                PRO</div>
            <!-- <div matTooltip="{{'This feature is in beta testing'|translate}}"
                class="px-2 py-1 rounded-sm bg-yellow-500 text-white shadow-md  font-extrabold  text-lg">
                BETA</div> -->
            <div class="text-3xl font-bold">{{'Download files by driver and vehicle' | translate}}</div>
        </div>
        <div class="w-full flex flex-row gap-2 justify-between">
            <div class="flex flex-row gap-2 flex-wrap">
                <label class="flex flex-col">
                    <div class="text-slate-500">{{'Select company'| translate}}</div>
                    <p-dropdown [options]="companies" [(ngModel)]="selectedCompanyForEntities" c
                        (onChange)="onCompanyChangeForEntities()" placeholder="{{'Select company' | translate}}"
                        optionLabel="name" [filter]="true" filterBy="name" [virtualScroll]="true" itemSize="50"
                        [style]="{'width':'20rem'}">
                    </p-dropdown>
                </label>
                <label class="flex flex-col">
                    <div class="text-slate-500">{{'Select drivers'| translate}}</div>
                    <div class="flex flex-row gap-2 items-center">
                        <p-multiSelect [options]="drivers" [(ngModel)]="selectedDrivers" [style]="{'width':'20rem'}"
                            [disabled]="!selectedCompanyForEntities || driversLoading"
                            defaultLabel="{{'Select drivers' | translate}}" optionLabel="name" [filter]="true"
                            filterBy="name" [virtualScroll]="true" itemSize="50" display="chip">
                            <ng-template let-value pTemplate="selectedItems">
                                <div *ngIf="!value || value.length==0" class="w-64 h-6">
                                    {{'Select drivers' | translate}}
                                </div>
                                <div *ngIf="!!value && value.length>0" class="w-64 h-8 flex flex-col justify-center">
                                    {{value.length}} {{'drivers selected' | translate}}
                                </div>
                            </ng-template>
                        </p-multiSelect>
                        <div *ngIf="driversLoading" role="status">
                            <svg aria-hidden="true"
                                class="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-tachosafe-500"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor" />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill" />
                            </svg>
                        </div>
                    </div>
                </label>
                <label class="flex flex-col">
                    <div class="text-slate-500">{{'Select vehicles'| translate}}</div>
                    <div class="flex flex-row gap-2 items-center">
                        <p-multiSelect [options]="vehicles" [(ngModel)]="selectedVehiclesForDownload"
                            [disabled]="!selectedCompanyForEntities || vehiclesLoading"
                            defaultLabel="{{'Select vehicles' | translate}}" optionLabel="registrationNumber"
                            [filter]="true" filterBy="registrationNumber" [virtualScroll]="true" itemSize="50"
                            display="chip">
                            <ng-template let-value pTemplate="selectedItems">
                                <div *ngIf="!value || value.length==0" class="w-64 h-6">
                                    {{'Select vehicles' | translate}}
                                </div>
                                <div *ngIf="!!value && value.length>0" class="w-64 h-8 flex flex-col justify-center">
                                    {{value.length}} {{'Vehicles selected' | translate}}
                                </div>
                            </ng-template>
                            <ng-template let-vehicle pTemplate="item">
                                <div class="flex flex-row gap-2">
                                    <div class="flex flex-col">
                                        <div class="text-sm font-bold">{{vehicle?.registrationNumber}}</div>
                                        <div class="text-xs text-slate-500">{{vehicle?.vin}}</div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                        <div *ngIf="vehiclesLoading" role="status">
                            <svg aria-hidden="true"
                                class="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-tachosafe-500"
                                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor" />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill" />
                            </svg>
                        </div>
                    </div>
                </label>
                <label class="flex flex-col">
                    <div class="text-slate-500 inline-flex flex-row gap-1 items-center">
                        {{'Select period'| translate}}
                        <mat-icon class="text-base w-4 h-4"
                            matTooltip="{{'Period refers to when files were uploaded'|translate}}">info</mat-icon>
                    </div>
                    <p-calendar placeholder="{{'Select period' | translate}}" [(ngModel)]="rangeDatesPerEntity"
                        selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>
                </label>
                <!-- <label class="flex flex-col">
                    <div class="text-slate-500">{{'TC Format'| translate}}</div>
                    <p-dropdown [options]="tcFormatOptions" [(ngModel)]="selectedTcFormat"
                        placeholder="{{'Select TC format' | translate}}"></p-dropdown>
                </label>
                <label class="flex flex-col">
                    <div class="text-slate-500">{{'DC Format'| translate}}</div>
                    <p-dropdown [options]="dcFormatOptions" [(ngModel)]="selectedDcFormat"
                        placeholder="{{'Select DC format' | translate}}"></p-dropdown>
                </label> -->
            </div>
            <button
                [disabled]="!!perEntityProgress || !selectedCompanyForEntities || (selectedDrivers.length === 0 && selectedVehiclesForDownload.length === 0) || !rangeDatesPerEntity || rangeDatesPerEntity.length === 0 || !isPro"
                (click)="downloadFilesPerEntities()"
                class="text-white px-2 py-1 bg-tachosafe-500 font-bold mt-5 disabled:bg-slate-300">{{'Download'|
                translate}}</button>
        </div>

        <div *ngIf="!!perEntityProgress" class="flex flex-col gap-2">
            <div>{{'Downloading..'|translate}}</div>
            <div class="w-full bg-tachosafe-200 rounded-full h-2.5 dark:bg-gray-700">
                <div class="bg-tachosafe-600 h-2.5 rounded-full" [style]="{width: perEntityProgress+'%'}"></div>
            </div>
        </div>
    </div>


    <div class="rounded-md shadow-md p-2 w-full bg-white flex flex-col gap-2">
        <div class="h-12 flex flex-row gap-4 items-center">
            <div matTooltip="{{'This feature is in beta testing'|translate}}"
                class="px-2 py-1 rounded-sm bg-tachosafe-500 text-white shadow-md  font-extrabold  text-lg">
                PRO</div>
            <!-- <div matTooltip="{{'This feature is in beta testing'|translate}}"
                class="px-2 py-1 rounded-sm bg-yellow-500 text-white shadow-md  font-extrabold  text-lg">
                BETA</div> -->
            <div class="text-3xl font-bold">{{'Download files for Authorities' | translate}}</div>
        </div>
        <div class="w-full flex flex-row gap-2 justify-between">
            <div class="flex flex-row gap-2 justify-between w-full">
                <div class="flex flex-row gap-2 w-full">
                    <label class="flex flex-col">
                        <div class="text-slate-500">{{'Select vehicles'| translate}}</div>
                        <p-multiSelect [options]="vehicles" [(ngModel)]="selectedVehicles"
                            defaultLabel="{{'Select vehicles' | translate}}" optionLabel="registrationNumber"
                            [filter]="true" filterBy="registrationNumber" [virtualScroll]="true" itemSize="50"
                            display="chip">
                            <ng-template let-value pTemplate="selectedItems">
                                <div *ngIf="!value || value.length==0" class="w-64 h-6">
                                    {{'Select vehicles' | translate}}
                                </div>
                                <div *ngIf="!!value && value.length>0" class="w-64 h-8 flex flex-col justify-center">
                                    {{value.length}} {{'Vehicles selected' | translate}}
                                </div>
                            </ng-template>
                            <ng-template let-vehicle pTemplate="item">
                                <div class="flex flex-row gap-2">
                                    <div class="flex flex-col">
                                        <div class="text-sm font-bold">{{vehicle?.registrationNumber}}</div>
                                        <div class="text-xs text-slate-500">{{vehicle?.vin}}</div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                    </label>
                    <label class="flex flex-col">
                        <div class="text-slate-500">{{'Select period'| translate}}</div>
                        <p-calendar placeholder="{{'Select period' | translate}}" [(ngModel)]="rangeDatesAuthorities"
                            selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>
                    </label>
                    <button
                        [disabled]="!!authoritiesLoading || selectedVehicles.length===0 || !rangeDatesAuthorities|| rangeDatesAuthorities.length ===0 || !isPro"
                        (click)="checkFilesForAuthorities()"
                        class="text-white px-2 py-2 bg-tachosafe-500 h-10 font-bold mt-5 disabled:bg-slate-300">{{'Verify'|
                        translate}}</button>
                    <div *ngIf="!!authoritiesLoading" role="status" class="flex flex-col pb-2 justify-end">
                        <svg aria-hidden="true"
                            class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-tachosafe-500"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                        <span class="sr-only">{{'Loading' | translate}}</span>
                    </div>
                </div>
                <button *ngIf="analysisStatus === 'missing'" [disabled]="!!authoritiesLoading || !isPro"
                    (click)="downloadFilesForAuthorities()"
                    class="text-white px-2 py-1 bg-tachosafe-500 font-bold mt-5 disabled:bg-slate-300">{{'Download
                    anyway'|
                    translate}}</button>
                <button *ngIf="analysisStatus === 'covered'" [disabled]="!!authoritiesLoading|| !isPro"
                    (click)="downloadFilesForAuthorities()"
                    class="text-white px-2 py-1 bg-tachosafe-500 font-bold mt-5 disabled:bg-slate-300">{{'Download'|
                    translate}}</button>
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <div *ngIf="!!analysisStatus" class="flex flex-row gap-2 items-center">
                <div class="font-bold">
                    {{'Status' | translate}}:
                </div>
                <div *ngIf="analysisStatus === 'covered'" class="flex flex-row gap-2 items-center">
                    <mat-icon class="text-green-500">check_circle</mat-icon>
                    <div class="font-bold">{{'OK' | translate}}</div>
                </div>
                <div *ngIf="analysisStatus === 'missing'" class="flex flex-row gap-2 items-center">
                    <mat-icon class="text-orange-500">warning</mat-icon>
                    <div class="font-bold">{{'Incomplete' | translate}}</div>
                </div>
            </div>
            <div *ngIf="analysisStatus === 'missing'"
                class="px-2 py-1 rounded-md bg-orange-100 border-orange-500 border-1 border">{{"Your files are
                incomplete, please upload the files for the missing periods" | translate}}</div>
            <div *ngIf="analysisStatus === 'covered'"
                class="px-2 py-1 rounded-md bg-green-100 border-green-500 border-1 border">{{"Your files are complete" |
                translate}}</div>
            <p-table *ngIf="dataTableRows.length" [value]="dataTableRows" styleClass="p-datatable-sm" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="w-32">
                            {{'Status' | translate}}
                        </th>
                        <th>
                            {{'Name' | translate}}
                        </th>
                        <th>
                            {{'Tachograph status' | translate}}
                        </th>
                        <th>
                            {{'Driver status' | translate}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" size let-rowData let-expanded="expanded">
                    <tr *ngIf="rowData.type === 'vehicleHeader'">
                        <td class="w-10">
                            <mat-icon *ngIf="rowData.status === 'covered'"
                                class="text-green-500">check_circle</mat-icon>
                            <mat-icon *ngIf="rowData.status === 'missing'" class="text-orange-500">warning</mat-icon>
                        </td>
                        <td>
                            <div class="flex flex-col">
                                <div class="text-sm font-bold">{{rowData?.registrationNumber}}</div>
                                <div class="text-xs text-slate-500">{{rowData?.vin}}</div>
                            </div>
                        </td>
                        <td>
                            <div class="flex flex-col gap-1">
                                <span *ngIf="rowData.missingPeriods.length > 0">{{'Missing period'}}:</span>
                                <div *ngFor="let period of rowData.missingPeriods">
                                    <div
                                        class="bg-orange-100 border-orange-500 border-1 border rounded-md px-1 flex flex-row justify-center w-52 ">
                                        {{period.start}} - {{period.end}}</div>
                                </div>
                            </div>
                            <div *ngIf="rowData.missingPeriods.length === 0">
                                <mat-icon matTooltip="{{'Tachograph is ok'|translate}}"
                                    class="text-green-500">check_circle</mat-icon>
                            </div>
                        </td>
                        <td>
                            <!-- <mat-icon *ngIf="rowData.vehicleStatus === 'covered'"
                                    class="text-green-500">local_shipping</mat-icon>
                                <mat-icon matTooltip="{{'Missing vehicle file'|translate}}"
                                    *ngIf="rowData.vehicleStatus === 'missing'"
                                    class="text-orange-500">local_shipping</mat-icon> -->
                            <mat-icon *ngIf="rowData.driverStatus === 'covered'"
                                matTooltip="{{'Driver file is ok'|translate}}"
                                class="text-green-500">check_circle</mat-icon>
                            <mat-icon matTooltip="{{'Missing driver file'|translate}}"
                                *ngIf="rowData.driverStatus === 'missing'" class="text-orange-500">warning</mat-icon>
                        </td>
                    </tr>
                </ng-template>

            </p-table>
            <p-table class="mt-6" *ngIf="missingDrivers.length" [value]="missingDrivers" styleClass="p-datatable-sm"
                dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th>
                            {{'Drivers' | translate}}
                        </th>
                        <th>
                            {{'Status' | translate}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" size let-rowData let-expanded="expanded">
                    <tr>
                        <td>
                            {{rowData.name}}
                        </td>
                        <td>
                            <mat-icon *ngIf="rowData.status === 'covered'"
                                matTooltip="{{'Driver file is ok'|translate}}"
                                class="text-green-500">check_circle</mat-icon>
                            <mat-icon matTooltip="{{'Missing driver file'|translate}}"
                                *ngIf="rowData.status === 'missing'" class="text-orange-500">warning</mat-icon>
                        </td>
                    </tr>
                </ng-template>

            </p-table>
            <div *ngIf="missingDrivers.length" class="text-xl m-4">
                {{'For more information, visit the' | translate}}: <a
                    class="text-tachosafe-500 hover:underline font-bold" routerLink="/report/vehiclereport">{{'Vehicle
                    report' | translate}}</a>
            </div>
        </div>
    </div>


</div>